import { Builder } from '@builder.io/sdk';
import { PageHeroImage } from './PageHeroImage';
import {
  FIXED_DURATION_ONE_DAY,
  FIXED_DURATION_ONE_WEEK,
  FIXED_DURATION_TWO_DAYS,
} from '../LandingPageForm/LandingPageForm';
import { BuilderInputOptions } from '@/types/builder';
import { journeyInput, showDurationPickerInput } from '../LandingPageForm/LandingPageForm.registry';

const ProductHeroImageConfig = {
  name: 'PageHeroImage',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'subtitle',
      type: 'string',
      required: false,
      showIf: (options: BuilderInputOptions) => !options?.get('headingOnly'),
    },
    journeyInput,
    {
      name: 'regLabel',
      type: 'string',
      required: false,
      defaultValue: 'Enter Registration Number',
      description: 'Label for the registration number field',
      showIf: (options: BuilderInputOptions) => !!options?.get('enableForm'),
    },
    {
      name: 'defaultDuration',
      type: 'string',
      required: false,
      defaultValue: FIXED_DURATION_TWO_DAYS,
      enum: [
        { label: 'One day', value: FIXED_DURATION_ONE_DAY },
        { label: 'Two days', value: FIXED_DURATION_TWO_DAYS },
        { label: 'One week', value: FIXED_DURATION_ONE_WEEK },
      ],
      description: 'Default duration for the form',
      showIf: (options: BuilderInputOptions) => !!options?.get('enableForm'),
    },
    showDurationPickerInput,
    {
      name: 'image',
      type: 'file',
      required: true,
    },
  ],
};

Builder.registerComponent(PageHeroImage, ProductHeroImageConfig);
